import { createAction } from "@reduxjs/toolkit";

import {
  setLocationBlockerActionTypes,
  deleteLocationBlockerActionTypes,
  getLocationBlockerLocationsActionTypes,
} from "./actionTypes";

export const getLocationBlockerLocations = createAction(
  getLocationBlockerLocationsActionTypes.request,
  (payload) => ({ payload }),
);
export const getLocationBlockerLocationsSuccess = createAction(
  getLocationBlockerLocationsActionTypes.success,
  (payload) => ({ payload }),
);
export const getLocationBlockerLocationsFailure = createAction(
  getLocationBlockerLocationsActionTypes.failure,
  (payload) => ({ payload }),
);

export const setLocationBlocker = createAction(
  setLocationBlockerActionTypes.request,
  (payload) => ({ payload }),
);
export const setLocationBlockerSuccess = createAction(
  setLocationBlockerActionTypes.success,
  (payload) => ({ payload }),
);
export const setLocationBlockerFailure = createAction(
  setLocationBlockerActionTypes.failure,
  (payload) => ({ payload }),
);

export const deleteLocationBlocker = createAction(
  deleteLocationBlockerActionTypes.request,
  (payload) => ({ payload }),
);
export const deleteLocationBlockerSuccess = createAction(
  deleteLocationBlockerActionTypes.success,
  (payload) => ({ payload }),
);
export const deleteLocationBlockerFailure = createAction(
  deleteLocationBlockerActionTypes.failure,
  (payload) => ({ payload }),
);
